"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const GtmDataLayer_1 = __importDefault(require("@react/common/GtmDataLayer/GtmDataLayer"));
const addSubscriptionPriceOfferToFavorites = (offerId) => {
    (0, GtmDataLayer_1.default)({
        event: 'likePriceOffer',
        offer: {
            offerId,
        },
    });
};
exports.default = addSubscriptionPriceOfferToFavorites;
